import * as React from "react";
import StringHelper from "~/utils/StringHelper";
import RunbooksNavigationTabs from "../RunbooksNavigationTabs";
import type { TabbedFormPaperLayoutProps } from "./TabbedFormPaperLayout";
import TabbedFormPaperLayout from "./TabbedFormPaperLayout";
type RunbooksFormPaperLayoutProps = TabbedFormPaperLayoutProps;
const RunbooksFormPaperLayout: React.FC<RunbooksFormPaperLayoutProps> = ({ tabNavigation = RunbooksNavigationTabs, breadcrumbTitle = "Runbooks", title = StringHelper.ellipsis, disableAnimations = true, fullWidth = true, ...rest }) => (<TabbedFormPaperLayout breadcrumbTitle={breadcrumbTitle} title={title} tabNavigation={tabNavigation} disableAnimations={disableAnimations} fullWidth={fullWidth} {...rest}/>);
RunbooksFormPaperLayout.displayName = "RunbooksFormPaperLayout"
export default RunbooksFormPaperLayout;
